import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
	CardElement,
	Elements,
	useStripe,
	useElements,
} from "@stripe/react-stripe-js";
// import { arrow } from "../../constant";
// import "../../assets/css/Stripform.css";
// import { toast } from "react-toastify";

// const stripePromise = loadStripe(
// 	"pk_test_51La0zBG1ZOvvMhkPKL0FRFxaVVLAnY11sRarA6EkCsZWGFqTogFRNYpGBK2xlEflcVseZ9TADFwHGwnjZly5jUZk000lYIUwda",
// );

// ⭐ Load stripe key from ENV
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const CheckoutForm = (props) => {
	const { styling, handleClickOpen, paynow, PaymentHandler, loading } = props;
	const [formData, setFormData] = useState({});
	const [payProcessing, setPayProcessing] = useState(false);
	const [done, setDone] = useState(false);

	const stripe = useStripe();
	const elements = useElements();
	const [paybutton, setPayButton] = useState(true);

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!stripe || !elements) {
			return;
		}
		setPayProcessing(true); // Disable button on click
		const cardElement = elements.getElement(CardElement);
		const payload = await stripe.createToken(cardElement);
		if (payload?.token?.id) {
			await PaymentHandler(e, payload?.token?.id);
			return;
		} else {
			setPayProcessing(false);
			//   toast.error("Something Went Wrong");
			return;
		}
		setPayProcessing(true);
		setDone(true);
		setPayProcessing(false);
	};

	const stylestrip = {
		marginTop: "30px",
	};

	return (
		<>
			<form style={stylestrip} onSubmit={handleSubmit}>
				<CardElement
					onChange={(e) => {
						if (e.complete) {
							setPayButton(false);
						} else {
							setPayButton(true);
						}
					}}
				/>
				<br />

				<ul className="list-inline">
					<li>
						<button
							type="submit"
							style={{
								...styling,
								color: "#fff",
							}}
							className="stripePay-Btn f-14 f-pop-med btn fullbtn hoverbtn"
							disabled={
								!stripe || !elements || paybutton || loading || payProcessing
							}
							onClick={(e) => handleSubmit(e)}
						>
							{loading || payProcessing ? "Processing..." : paynow}
						</button>
					</li>
				</ul>
			</form>
		</>
	);
};

const StripeForm = (props) => {
	const { styling, paynow, PaymentHandler, loading } = props;
	return (
		<Elements stripe={stripePromise}>
			<CheckoutForm
				styling={styling}
				paynow={paynow}
				className="strip_data"
				PaymentHandler={PaymentHandler}
				loading={loading}
			/>
		</Elements>
	);
};

export default StripeForm;
